import { AxiosInstance } from 'axios';
import { PartnerOrMaster } from 'types/partner';
import { Result } from 'services/Result';

export class MastersService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getMasters = async () => {
    const response = await this.axiosInstance.get<Result<PartnerOrMaster[]>>(`api/masters`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching masters.');
  };
}

export default MastersService;
